var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":_vm.getCols()}},[_c('next-withdrawals')],1),_c('b-col',{attrs:{"cols":_vm.getCols()}},[_c('payment-evolution')],1),_c('b-col',{attrs:{"cols":_vm.getCols()}},[_c('summary-current-month')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }